export interface AdjustmentDiscount {
    item: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentDiscountProps {
    item: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentDiscount = (obj: ObjectToAdjustmentDiscountProps): AdjustmentDiscount => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}